import IconPrimary from '../icon-primary/IconPrimary'
export default IconPrimary
export * from '../icon-primary/IconPrimary'
